import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import Button from '../elements/Button';

const propTypes = {
    ...SectionTilesProps.types
}

const defaultProps = {
    ...SectionTilesProps.defaults
}
const FeaturesTiles = ({
    className,
    topOuterDivider,
    bottomOuterDivider,
    topDivider,
    bottomDivider,
    hasBgColor,
    invertColor,
    pushLeft,
    ...props
}) => {

    const outerClasses = classNames(
        'features-tiles section',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'features-tiles-inner section-inner pt-0',
        topDivider && 'has-top-divider',
        bottomDivider && 'has-bottom-divider'
    );

    const tilesClasses = classNames(
        'tiles-wrap center-content',
        pushLeft && 'push-left'
    );

    const sectionHeader = {
        title: 'Visores Geográficos',
        paragraph: 'A través de los siguientes visores de la corporación, usted puede conocer las características de las variables ambientales en la jurisdicción de la corporación y hacer seguimiento de los diferentes componentes naturales y socio económicos.'
    };

    return (
        <section
            {...props}
            className={outerClasses}>
            <div className="container">
                <div className={innerClasses}>
                    <SectionHeader data={sectionHeader} className="center-content cont-viewers-geo" />
                    <div className={tilesClasses}>
                        <div className="tiles-item reveal-from-bottom">
                            <div className="tiles-item-inner cont-viewer-geo">
                                <div className="features-tiles-item-header">
                                    <div className="features-tiles-item-image mb-16">
                                        <a target="_blank" href="/visor?info=Agua">
                                            <Image
                                                className="img-viewers-geo"
                                                src={require('../../assets/images/visores/icon_agua.png')}
                                                alt="Features tile icon 01"
                                                width={300}
                                                height={148} />
                                        </a>
                                    </div>
                                </div>
                                <div className="features-tiles-item-content">
                                    <h4 className="mt-0 mb-8">Agua</h4>
                                    <p className="m-0 text-sm features-p-item-content">
                                        Información asociada a la oferta o disponibilidad del recurso hídrico mediante información meteorológica, así mismo variables asociadas a la demanda del recurso hídrico.
                                    </p>
                                    <Button className="fw-normal button-viewer-geo"
                                        tag="a" target="_blank" color="primary"
                                        wideMobile href="/visor?info=Agua">Geovisor</Button>
                                    <h5 className="mt-0 mb-8 text-sm">- Indicadores -</h5>
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/4eb782ea2d964c6099c7dc2e095c141f">Panel Indicador ICAL</Button>
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/9d777ea29c3c460086913ac0a8bc6ad3">Panel Índice Calidad de Agua</Button> 
                                </div>
                            </div>
                        </div>

                        <div className="tiles-item reveal-from-bottom">
                            <div className="tiles-item-inner cont-viewer-geo">
                                <div className="features-tiles-item-header">
                                    <div className="features-tiles-item-image mb-16">
                                        <a target="_blank" href="/visor?info=Geomorfologia">
                                            <Image
                                                className="img-viewers-geo"
                                                src={require('../../assets/images/visores/icon_geomorfolia.png')}
                                                alt="Features tile icon 01"
                                                width={300}
                                                height={148} />
                                        </a>
                                    </div>
                                </div>
                                <div className="features-tiles-item-content">
                                    <h4 className="mt-0 mb-8">Geomorfología</h4>
                                    <p className="m-0 text-sm features-p-item-content">
                                        Datos geográficos sobre las condiciones del relieve en cuanto a sus características fisiográficas y morfodinámicas, así mismo datos relevantes sobre nuestras áreas con amenazas naturales.
                                    </p>
                                    <Button className="fw-normal button-viewer-geo"
                                        tag="a" target="_blank" color="primary"
                                        wideMobile href="/visor?info=Geomorfologia">Geovisor</Button>
                                    <h5 className="mt-0 mb-8 text-sm">- Indicadores -</h5>
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/b8ab397575154c288da1d0c97d7e1783">Movimientos en Masa</Button>
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/2cd2aa9e53d94ce2ac1bbbaaa9ea7ca2">Avenidas Torrenciales</Button>
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/de7e56848ef3441a97beb15ba90d989f">Amenaza por Inudación</Button>

                                </div>
                            </div>
                        </div>

                        <div className="tiles-item reveal-from-bottom">
                            <div className="tiles-item-inner cont-viewer-geo">
                                <div className="features-tiles-item-header">
                                    <div className="features-tiles-item-image mb-16">
                                        <a target="_blank" href="/visor?info=Suelo">
                                            <Image
                                                className="img-viewers-geo"
                                                src={require('../../assets/images/visores/icon_suelo.png')}
                                                alt="Features tile icon 01"
                                                width={300}
                                                height={148} />
                                        </a>
                                    </div>
                                </div>
                                <div className="features-tiles-item-content">
                                    <h4 className="mt-0 mb-8">Suelo</h4>
                                    <p className="m-0 text-sm features-p-item-content">
                                        Información asociada a las condiciones y características potenciales del suelo para uso productivo, así mismo información taxonómica de los suelos presentes en la jurisdicción de la corporación.
                                    </p>
                                    <Button className="fw-normal button-viewer-geo"
                                        tag="a" target="_blank" color="primary"
                                        wideMobile href="/visor?info=Suelo">Geovisor</Button>
                                        <br></br>
                                    <h5 className="mt-0 mb-8 text-sm">- Indicadores -</h5>
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/621ccd6756124745a126e0ce3cdaf613">Clases Agrológicas</Button>
                                </div>
                            </div>
                        </div>

                        <div className="tiles-item reveal-from-bottom">
                            <div className="tiles-item-inner cont-viewer-geo">
                                <div className="features-tiles-item-header">
                                    <div className="features-tiles-item-image mb-16">
                                        <a target="_blank" href="/visor?info=Biodiversidad">
                                            <Image
                                                className="img-viewers-geo"
                                                src={require('../../assets/images/visores/icon_biodiversidad.png')}
                                                alt="Features tile icon 01"
                                                width={300}
                                                height={148} />
                                        </a>
                                    </div>
                                </div>
                                <div className="features-tiles-item-content">
                                    <h4 className="mt-0 mb-8">Biodiversidad</h4>
                                    <p className="m-0 text-sm features-p-item-content">
                                        Presenta la información geográfica temática con relación a las coberturas de la tierra, los ecosistemas y las áreas protegidas entre otras capas, correspondientes a la jurisdicción de la corporación.
                                    </p>
                                    <Button className="fw-normal button-viewer-geo"
                                        tag="a" target="_blank" color="primary"
                                        wideMobile href="/visor?info=Biodiversidad">Geovisor</Button>
                                        <br></br>
                                    <h5 className="mt-0 mb-8 text-sm">- Indicadores -</h5>
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/c9733d286c1e4d0380d41170db115cc9">Representatividad</Button>
                                    <Button className="fw-normal button-dashboard-geo"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/779b6f289edd4bb99a263c93d6b068c2">Tasa de Deforestación</Button>
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/a4efa65fb7b6467ca8b39c63b04d04c3">Aprovechamiento Forestal</Button>    
      
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/c5a7ba528a374203bdb16e9587e0e2a6">Remanencia</Button>    
                                </div>
                            </div>
                        </div>

                        <div className="tiles-item reveal-from-bottom">
                            <div className="tiles-item-inner cont-viewer-geo">
                                <div className="features-tiles-item-header">
                                    <div className="features-tiles-item-image mb-16">
                                        <a target="_blank" href="/visor?info=Aire">
                                            <Image
                                                className="img-viewers-geo"
                                                src={require('../../assets/images/visores/icon_aire.png')}
                                                alt="Features tile icon 01"
                                                width={300}
                                                height={148} />
                                        </a>
                                    </div>
                                </div>
                                <div className="features-tiles-item-content">
                                    <h4 className="mt-0 mb-8">Aire</h4>
                                    <p className="m-0 text-sm features-p-item-content">
                                        Identifica la información de seguimiento y monitoreo del aire en la ciudad de Bucaramanga, siendo ésta la principal área urbana de la jurisdicción de la corporación.
                                    </p>
                                    <Button className="fw-normal button-viewer-geo"
                                        tag="a" target="_blank" color="primary"
                                        //wideMobile href="/visor?info=Aire">Geovisor</Button>
                                        wideMobile href="https://suite.ambiensq.com/#!/mapaMonitoreo/cdmb">Geovisor</Button> 
                                </div>
                            </div>
                        </div>

                        <div className="tiles-item reveal-from-bottom">
                            <div className="tiles-item-inner cont-viewer-geo">
                                <div className="features-tiles-item-header">
                                    <div className="features-tiles-item-image mb-16">
                                        <a target="_blank" href="/visor?info=SostenibilidadUrbana">
                                            <Image
                                                className="img-viewers-geo"
                                                src={require('../../assets/images/visores/icon_urbano.png')}
                                                alt="Features tile icon 01"
                                                width={300}
                                                height={148} />
                                        </a>
                                    </div>
                                </div>
                                <div className="features-tiles-item-content">
                                    <h4 className="mt-0 mb-8">Sostenibilidad Urbana</h4>
                                    <p className="m-0 text-sm features-p-item-content">
                                        Asocia la información de atributos y datos poblacionales de las grandes áreas urbanas presentes en la corporación, así mismo presenta datos relacionados con calidad de vida y condiciones de vivienda y espacio público.
                                    </p>
                                    <Button className="fw-normal button-viewer-geo"
                                        tag="a" target="_blank" color="primary"
                                        wideMobile href="/visor?info=SostenibilidadUrbana">Geovisor</Button>
                                    <h5 className="mt-0 mb-8 text-sm">- Indicadores -</h5>
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/adcf69793e134ac4be16006f726ebfb1">Alcantarillado Municipios</Button> 
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/fcc0ae3c7d3f46ea9f6a1c5508524249">Acueducto Municipios</Button> 
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/cd86bb0db4b44f649d60de5fdb936713">Déficit Hab. Cualitativo</Button> 
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/8ebd76e19f4842f8b3c7b1b108ee39e9">Déficit Hab. Cuantitativo</Button> 

                                </div>
                            </div>
                        </div>

                        <div className="tiles-item reveal-from-bottom">
                            <div className="tiles-item-inner cont-viewer-geo">
                                <div className="features-tiles-item-header">
                                    <div className="features-tiles-item-image mb-16">
                                        <a target="_blank" href="/visor?info=Socioeconomico">
                                            <Image
                                                className="img-viewers-geo"
                                                src={require('../../assets/images/visores/icon_socioeconomico.png')}
                                                alt="Features tile icon 01"
                                                width={300}
                                                height={148} />
                                        </a>
                                    </div>
                                </div>
                                <div className="features-tiles-item-content">
                                    <h4 className="mt-0 mb-8">Socioeconómico</h4>
                                    <p className="m-0 text-sm features-p-item-content">
                                        Relaciona información de los sectores económicos de la población y condiciones productivas actuales y potenciales, así mismo presenta información demográfica, datos de las condiciones del sector educativo e información de áreas bajo algún tipo de riesgo natural.
                                    </p>
                                    <Button className="fw-normal button-viewer-geo"
                                        tag="a" target="_blank" color="primary"
                                        wideMobile href="/visor?info=Socioeconomico">Geovisor</Button>
                                    <h5 className="mt-0 mb-8 text-sm">- Indicadores -</h5>
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/403df6950a384f47b80dc59f474b4d8f">Producción Agropecuaria</Button>                                         
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/b2651e64a28a44d280adfe7497b110dd">Prod.Agrícola Piedecuesta</Button>                                         
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/34ebd666fa1d4ad3b4ad17bb790698b0">Producción Agrícola Giron</Button>                                         
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/049484cda0d2401c93737fee76772363">Producción Agrícola Bga.</Button>                                         
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/decc12c3c33547a4be8ce2ceec24a0b3">Prod. Agrícola Floridablanca</Button>                                         
                                    <Button className="fw-normal button-dashboard-geo text-sm"
                                        tag="a" target="_blank" color="secondary"
                                        wideMobile href="https://sigcdmb.maps.arcgis.com/apps/dashboards/43335585b1654ec9b1545a7aaf9035df">Producción Pecuaria</Button>                                         
                                </div>
                            </div>
                        </div>

                        {/* <div className="tiles-item reveal-from-bottom">
                            <div className="tiles-item-inner cont-viewer-geo">
                                <div className="features-tiles-item-header">
                                    <div className="features-tiles-item-image mb-16">
                                        <a target="_blank" href="/visor?info=Economico">
                                            <Image
                                                src={require('../../assets/images/visores/geovisor_cdmb_tn.jpg')}
                                                alt="Features tile icon 01"
                                                width={300}
                                                height={148} />
                                        </a>
                                    </div>
                                </div>
                                <div className="features-tiles-item-content">
                                    <h4 className="mt-0 mb-8">Económico</h4>
                                    <p className="m-0 text-sm features-p-item-content">
                                        Resumen corto del contenido del visor.
                                        Resumen corto del contenido del visor.
                                        Resumen corto del contenido del visor.
                                    </p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    );
}

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default FeaturesTiles;
